export function getRoundedAxisMaximum(maximum: number, interval: number): number {
  if (!Number.isFinite(maximum) || !Number.isFinite(interval) || interval <= 0) return 0;
  return Math.max(interval, Math.ceil(Math.max(0, maximum) / interval) * interval);
}

export function getRoundedDomain(
  values: number[],
  interval: number,
  requiredValues: number[] = [],
): [number, number] {
  if (!Number.isFinite(interval) || interval <= 0) return [0, 0];

  const finiteValues = [...values, ...requiredValues].filter(Number.isFinite);
  if (finiteValues.length === 0) return [-interval, interval];

  const minimum = Math.floor(Math.min(...finiteValues) / interval) * interval;
  const maximum = Math.ceil(Math.max(...finiteValues) / interval) * interval;

  if (minimum === maximum) return [minimum - interval, maximum + interval];
  return [minimum, maximum];
}

export function getTicksBetween(minimum: number, maximum: number, interval: number): number[] {
  if (
    !Number.isFinite(minimum) ||
    !Number.isFinite(maximum) ||
    !Number.isFinite(interval) ||
    interval <= 0 ||
    maximum < minimum
  ) {
    return [];
  }

  return Array.from(
    { length: Math.floor((maximum - minimum) / interval) + 1 },
    (_value, index) => minimum + index * interval,
  );
}

export function getFirstPositiveTimestamp(timestamps: number[]): number {
  return (
    timestamps.find((timestamp) => Number.isFinite(timestamp) && timestamp > 0) ??
    timestamps.find(Number.isFinite) ??
    0
  );
}

export function formatTickAtInterval(value: string | number, interval: number): string {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue) || numericValue % interval !== 0) return "";
  return String(numericValue);
}
